<template>
  <v-container>
    <v-card cols="12" elevation="0">
      <v-col>
        <v-row v-html="article"></v-row>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
import { eventEmitter } from "../main";
import axios from "axios";

export default {
  components: {},
  metaInfo: {
    title: "Services",
    titleTemplate: "%s | iLook.su",
  },
  data() {
    return {
      name: this.$router.currentRoute.params["id"],
      article: "",
    };
  },
  watch: {
    article() {
      this.$nextTick(() => {
        let titleTextEl = document.getElementById("title");
        if (titleTextEl) {
          document.title = titleTextEl.innerHTML;
        }
      });
    },
  },
  computed: {
    isSingle(){
      return location.host == "ilook.su"
    },
  },
  methods: {
    pressOnLink() {
      this.$router.push({ name: "about" });
    },
    update() {
      console.log("update article");
      let config = {
        headers: {
          lang: this.$vuetify.lang.current,
        },
      };
      
      let type = "single"
      if (!this.isSingle){
        type = "corp"
      }

      let url = `https://file.ilook.su/AppInfo/api/article/${type}/${this.name}/`;
      axios
        .get(url, config)
        .then((response) => response.data)
        .then((data) => {
          if (data) {
            this.article = data;
            this.$nextTick(() => {
              let linkAboutMeEl = document.getElementById("link_about_me");
              if (linkAboutMeEl) {
                linkAboutMeEl.onclick = this.pressOnLink;
              }
            });
          }
        })
        .catch((error) => {
          this.article = error;
        });
    },
  },
  mounted() {
    this.update();
    let sheet = document.getElementById("scrolling_sheet");
    if (sheet) {
      sheet.scroll(0, 0);
    }
  },
  created() {
    eventEmitter.$on("updateLocale", () => {
      this.update();
    });
  },

  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    if (to.hash == "#scrollOnTop") {
      this.$store.commit("resetStoredPosition");
      next(to.path);
      return;
    }

    next();
  },
};
</script>


<style scoped>
</style>